import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/location_new/dallas/dallas_banner.webp";
import Bannerfrom from "../components/bannerfrom";

function Banner(props) {
  return (
    <div
      className="locationgcc_banner hosuton_banner"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h1>
                Mobile App Development Company <span>Dallas</span>
              </h1>
              <p className="main_para">
                At TekRevol, we excel in custom mobile app development services
                in Dallas across platforms. We build apps with intuitive
                usability and future-forward expansible frameworks for
                growth-ready rollout. With our team of full-stack mobile app
                developers in Dallas and novel product design toolkit,
                experience rapid prototyping, USP-driven functionalities, and
                full-scale launch.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Consult Your App Idea
              </Link>
            </div>
          </Col>
          <Col xs={12} md={5} lg={5} xl={5} xxl={6} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
